import ContentfulHelper from "./Contentful";
import PrismicHelper from "./Prismic";
import URLHelper from "../../../helpers/URLHelper";
import JsonFileHelper from "./JsonFile";
import MyJsonHelper from "./MyJson";
import { AuthenticationService } from "../../../Request/Authentication/authenticationService";
let manifest = require("../../../../content-manifest.json");
const queryString = require("query-string");

interface IParams {
  contentProps?: string;
  contentfulId?: string;
  prismicId?: string;
  myJsonId?: string;
  id?: string;
  fbId?: string;
  contentId?:string;
}

export default async function fetchContentProps(
  params: IParams = URLHelper.getUrlParams()
): Promise<{} | undefined> {
  let finalContent;
  if (params.contentProps) {
    console.log(`taking contentProps from URL params.`);
    finalContent = JSON.parse(params.contentProps);
  } else if (params.contentfulId) {
    const contentfulHelper = new ContentfulHelper();
    finalContent = await contentfulHelper.getEntry(params.contentfulId);
  } else if (params.prismicId) {
    const prismicHelper = new PrismicHelper();
    finalContent = removeCMSKeys(
      await prismicHelper.getEntry(params.prismicId)
    );
  } else if (params.id) {
    const jsonFileHelper = new JsonFileHelper();
    finalContent = await jsonFileHelper.getEntry(params.id);
  } else if (params.myJsonId) {
    const myJsonHelper = new MyJsonHelper();
    finalContent = await myJsonHelper.getJsonFromId(params.myJsonId);
  } else if (params.fbId) {
    let isBrowser = new Function(
      "try {return this===window;}catch(e){ return false;}"
    );

    if (!isBrowser()) {
      let authService = new AuthenticationService();
    }
    let content = await AuthenticationService.getContent({
      contentIds: [params.fbId]
    });
    finalContent = content[0].data;
  } else if(params.contentId){
    const jsonFileHelper = new JsonFileHelper();
    finalContent = await jsonFileHelper.getEntry(params.contentId);
  } else {
    const id = process.env.CONTENT_ID_TO_RUN;
    if (id) {
      const jsonFileHelper = new JsonFileHelper();
      finalContent = await jsonFileHelper.getEntry(id);
    } else {
      finalContent = {
        type: manifest.urlConfig.defaultContent
      };
      // console.error(`ERROR MESSAGE : Please provide valid content ID to run.`);
    }
  }
  URLHelper.initUrlParamsWithContentType(finalContent.type);
  return finalContent;
}

function removeCMSKeys(root): {} {
  if (!root || typeof root !== "object") {
    return root;
  }
  let removeKeys = ["stringVal"];
  for (let key of removeKeys) {
    if (root[key]) {
      let returnVal = root[key];
      delete root[key];
      return returnVal;
    }
  }
  for (let key in root) {
    root[key] = removeCMSKeys(root[key]);
  }
  return root;
}
